// Server-side feature flags, published by the application layout as
// <meta name="nfca-flag-..." content="true|false"> tags so any component,
// however deeply nested, can read them without extra props.
export const featureFlag = (name) => {
  if (typeof document === 'undefined') return false

  return document.querySelector(`meta[name="nfca-flag-${name}"]`)?.content === 'true'
}

// Event groups (one card per series such as Guitar Lessons) on the website.
// When on, listings ask the server to collapse groups with group=1.
export const eventGroupsOnWeb = () => featureFlag('event-groups')
